import React, { useContext } from 'react';
import { Button, Checkbox, Col, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import './styles.less';
import { EnrollmentFormContext } from '../../../../../../../../providers/EnrollmentFormContextProvider';

const PreviewUAFForm = ({ onFinish }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);

  return (
    <Form form={enrollmentForm} onFinish={onFinish}>
      <Row>
        <Col>
          <Form.Item
            name="uafDeclaration"
            rules={[
              {
                validator: (_, value) => {
                  if (!value) return Promise.reject(new Error('Debe aceptar la declaración'));
                  return Promise.resolve();
                },
              },
            ]}
            valuePropName="checked"
          >
            <Checkbox>
              <span className="previewUAF__checkbox--text">
                Declaro bajo juramento, que la información proporcionada en este formulario es
                completa y veraz.
              </span>
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[40]}>
        <Col lg={12} xs={24}>
          <Button
            className="enrollmentLegalFormContainer__button"
            style={{ marginTop: '30%' }}
            type="primary"
            htmlType="submit"
          >
            Continuar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

PreviewUAFForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default PreviewUAFForm;
